<app-dynamic-modal-form
  size="lg"
  [actions]="[{label: 'Rejeter la demande', class: 'btn-danger', icon: 'times'}]"
  [generator]="rejectRequestFormGeneratorService"
  (onSubmit)="onSubmit($event)"
  (onCancel)="onCancel()"
  [title]="'Rejet de la demande ' + (request && request.requestType === 'EDIT' ? 'de modification' : 'd\'ajout') + ' d\'utilisateur'"
  [object]="request">
  <ng-template let-object="object">
    <p class="text-info">
      <fa-icon icon="info-circle"></fa-icon>
      En validant ce formulaire, un mail de confirmation sera envoyé automatiquement au demandeur.
    </p>

    <h2>Rappel de la demande</h2>
    <hr/>
    @if(object.requestType === 'EDIT') {
      <app-user-request-comparator [asAdmin]="true" [request]="object"
                                   [user]="object.forContact"></app-user-request-comparator>
    } @else {
      <app-user-request-detail [request]="object" [categories]="categories" [crmUrl]="crmUrl"></app-user-request-detail>
    }
  </ng-template>
</app-dynamic-modal-form>
